import { render, staticRenderFns } from "./NutritionistDashboard2.vue?vue&type=template&id=550005f4&scoped=true&"
import script from "./NutritionistDashboard2.vue?vue&type=script&lang=js&"
export * from "./NutritionistDashboard2.vue?vue&type=script&lang=js&"
import style0 from "./NutritionistDashboard2.vue?vue&type=style&index=0&id=550005f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550005f4",
  null
  
)

export default component.exports